<div [formGroup]="formGroup">
  <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12">
      Please provide your casing plan below pursuant to [<a target="_blank" href="/law-library/05Qi6505VA7t2N89" rel="noopener noreferrer">OAC 1501:9-1-02(A)(6)</a>] that complies with [<a target="_blank" href="/law-library/05Qm1v05V9Pp0nkO" rel="noopener noreferrer">OAC 1501:9-1-08</a>]. <br />
    </div>
    @if (hideUpdateButton) {
      <div class="cell large-12 medium-12 small-12">
        <span class="red italic">Scroll to the right to input all information.  If a directional or horizontal well, the "Position" column and "Kickpoint" checkbox are required.</span>
      </div>
    } @else {
      <div class="cell large-9 medium-9 small-9">
        <span class="red italic">Scroll to the right to input all information.  If a directional or horizontal well, the "Position" column and "Kickpoint" checkbox are required.</span>
      </div>
      <div class="cell large-3 medium-3 small-3 text-align-right">
        <button class="button" (click)="updateDrawing()">Update Drawing</button>
      </div>
    }
  </div>
  <div style="max-height: 570px">
    <ag-grid-angular class="data-grid" [gridOptions]="gridOptions" [rowData]="data" aria-label="Casing Plan Grid"></ag-grid-angular>

  </div>
  @if (!isCasingPlanValid() && !isEdit) {
    <div class="error-container margin-top">
      @if (!hasSegmentWithValues) {
        <span><small class="error">At least one measurement field must be filled in.</small><br /></span>
      }
      @if (!positionsDistinct) {
        <span><small class="error">Each casing type with a measurement must have a distinct position.</small><br /></span>
      }
      @if (!positionsValid) {
        <span>@if (!positionsValid) {
          <small class="error">Each casing type with a measurement must have a defined position.</small>
        }<br /></span>
      }
      @if (!measurementsValid) {
        <span>@if (!measurementsValid) {
          <small class="error">Each casing type with a position must have at least one measurement.</small>
        }</span>
      }
    </div>
  }
  @if (!requirePositions) {
    <div class="error-container margin-top">
      @if (!positionsDistinct) {
        <span><small class="error">When using positions, each string should have a separate, distinct position, or schematic drawings may not generate correctly.</small><br /></span>
      }
      @if (!positionsValid) {
        <span><small class="error">When using position, each casing type with a measurement must have a defined position, or schematic drawings may not generate correctly.</small><br /></span>
      }
    </div>
  }
  <div>
    Tubing and packer may be optional for all well types except Class II Disposal and Class II Enhanced Recovery Wells. For these wells the tubing and packer are required to be set within 100 feet of the proposed injection zone. If the proposed casing plan does not contain tubing and packer information for Class II Disposal and Class II Enhanced Recovery Wells then the casing program will not be considered compliant and will be returned.
  </div>
  <casing-plan-schematic-modal [casingPlan]="casingPlan" [applicationNumber]="applicationNumber" (imageUpdated)="onSchematicUpdated($event)"></casing-plan-schematic-modal>
</div>


